export const ROUTES = {
  tourPlanner: '/',
  sessions: '/sessions',
  settings: '/settings',
} as const;
